import React from "react";
import PropTypes from "prop-types";
import xstream from "state-x-stream";
import { switchMap } from "rxjs";
import Track from "../../models/Track";

function controller({ props$ }) {
  return {
    dimensions: props$.pipe(switchMap(({ track }) => track.heightUpdated$)),
    axis: props$.pipe(switchMap(({ track }) => track.axisUpdated$)),
  };
}

function AxisRendererComp({ track, axis }) {
  return track.AxisRenderer && !track.isCollapsed ? (
    <div className="tw-flex">
      <div className="tw-border-r color-3 border-1 tw-relative backdrop-filter-blur-md tw-transition-colors transition-duration-200">
        <div className="bg-2 tw-opacity-50 tw-absolute tw-inset-0" />
        <track.AxisRenderer
          height={track.contentHeight}
          pTop={track.pTop}
          pBottom={track.pBottom}
          axisConf={axis}
          track={track}
          TickRenderer={track.TickRenderer}
        />
      </div>
      <div className="tw-flex-grow" />
    </div>
  ) : null;
}

AxisRendererComp.propTypes = {
  track: PropTypes.instanceOf(Track).isRequired,
  axis: PropTypes.shape({}).isRequired,
};

export default xstream(controller)(AxisRendererComp);
